import { datadogLogs } from '@datadog/browser-logs';
import { InitDataDog } from './types/init-datadog';

export function initDataDog({ token, env, service }: InitDataDog) {
  datadogLogs.init({
    clientToken: token,
    site: 'datadoghq.com',
    forwardErrorsToLogs: false,
    sampleRate: 100,
  });
  datadogLogs.setLoggerGlobalContext({
    env,
    service,
    host: window.location.hostname,
    referrer: document.referrer,
  });
}
